import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.logo-carousel').forEach(section => {
        const sliderContainer = section.querySelector('.lc-slider');
        if (!sliderContainer) {return;}

        const swiper = new Swiper(sliderContainer, {
            slidesPerView: 6,
            slidesPerGroup: 6,
            spaceBetween: 36,
            loop: false,
            speed: 1200,
            pagination: {
                el: section.querySelector('.lc-pagination'),
                clickable: true,
            },

            navigation: {
                prevEl: section.querySelector('.arrow-prev'),
                nextEl: section.querySelector('.arrow-next'),
            },

            breakpoints: {
                0: {
                    slidesPerView: 2,
                    slidesPerGroup: 2,
                    spaceBetween: 30,
                },
                576: {
                    slidesPerView: 3,
                    slidesPerGroup: 3,
                },
                992: {
                    slidesPerView: 5,
                    slidesPerGroup: 3,
                },
                1200: {
                    slidesPerView: 6,
                    slidesPerGroup: 3,
                },
            },
        });
    });
});